import { Router, NavigationEnd } from '@angular/router';
import { Component, OnInit } from '@angular/core';

import * as $ from 'jquery'
import { I18nService } from 'src/app/modules/i18n/i18n.service';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  public urls = environment.AppRedirectUrls;
  langFiles: any = {
    en: 'Dos_and_Donts_for_Citizens.pdf',
    hi: 'Dos_and_Donts_for_Citizens_Hindi.pdf',
    mr: 'Dos_and_Donts_for_Citizens.pdf',
    ml: 'Dos_and_Donts_for_Citizens.pdf',
    pb: 'Dos_and_Donts_for_Citizens.pdf',
    te: 'Dos_and_Donts_for_Citizens.pdf',
    gu: 'Dos_and_Donts_for_Citizens_Gujarati.pdf',
    as: 'Dos_and_Donts_for_Citizens.pdf',
    be: 'Dos_and_Donts_for_Citizens.pdf',
    ka: 'Dos_and_Donts_for_Citizens.pdf',
    or: 'Dos_and_Donts_for_Citizens_Odia.pdf',
    ta: 'Dos_and_Donts_for_Citizens_Tamil.pdf',
  };

  currLang = 'en';
  dosDontsFileName: any = 'Dos_and_Donts_for_Citizens.pdf';
  constructor(
    public i18nService: I18nService,
    public translate: TranslateService,
  ) {}
  ngOnInit(): void {
    this.currLang = this.translate.currentLang;
    this.translate.onLangChange.subscribe((e: any) => {
      this.dosDontsFileName = this.langFiles[this.translate.currentLang];
      this.currLang = this.translate.currentLang;
    });

  }


}
